// Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
import { SimplePoint } from '@/flightpath-components/models/SimplePoint';
import { kdTree } from 'kd-tree-javascript';

export class AltitudeFinder {
  /*
      Using the altitude from a 3d dataset add altitude to a 2d dataset by using finding the closest point in the 3d dataset 
      using a kdtree lookup 
    */
  static Find(threeDData: SimplePoint[], twoDData: SimplePoint[]): SimplePoint[] {
    const tree = new kdTree(threeDData, AltitudeFinder.distancekm, ['Lat', 'Long']);
    const updatedPath: SimplePoint[] = [];
    twoDData.forEach((e) => {
      const nearest = tree.nearest({ Lat: e.Lat, Long: e.Long, Alt: 0 }, 1, 20000).pop(); // find nearest point within 20000km
      let alt = 0;
      if (nearest != undefined) {
        alt = nearest?.[0].Alt;
      }
      updatedPath.push({ Lat: e.Lat, Long: e.Long, Alt: alt });
    });
    return updatedPath;
  }

  /*
      Get the distance between two points in km using the haversine calculation
    */
  static distancekm(a: SimplePoint, b: SimplePoint) {
    const R = 6371; // Radius of the Earth in km
    const rlat1 = a.Lat * (Math.PI / 180); // Convert degrees to radians
    const rlat2 = b.Lat * (Math.PI / 180); // Convert degrees to radians
    const difflat = rlat2 - rlat1; // Radian difference (latitudes)
    const difflon = (b.Long - a.Long) * (Math.PI / 180); // Radian difference (longitudes)
    const d =
      2 *
      R *
      Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
    return d;
  }
}
